import type { GenderSummaryShellProps } from '@/modules/admin/pages/components/GenderSummaryShell/GenderSummaryShell.types'

import { GenderSummary } from '@/components/@Shared/UserManagmentCharts/GenderSummary/GenderSummary'

import { useAdminStatsServiceAdminStatsControllerGetGenderStats } from '@/__generated__/queries'

export function GenderSummaryShell({
  company,
  onUpdateChartsData,
}: GenderSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useAdminStatsServiceAdminStatsControllerGetGenderStats({
      company,
    })

  return (
    <GenderSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
